// extracted by mini-css-extract-plugin
export default {"infoCardWrapper":"appointmentPreview_infoCardWrapper__4wnLN","divider":"appointmentPreview_divider__298DV","hist":"appointmentPreview_hist__q3WBi"};